import classNames from 'classnames';
import {FC, FunctionComponent} from 'react';

type Props = {
    icon: FunctionComponent<React.SVGProps<SVGSVGElement>>;
    className?: string;
};
export const ReactComponentIcon: FC<Props> = ({
    icon: IconComponent,
    className,
}) => {
    return <IconComponent className={classNames(className, '-no-restyle')} />;
};
